import { BzDateFns, bzExpect, LocalDateString } from '@breezy/shared'
import { DatePickerProps } from 'antd'
import classNames from 'classnames'
import React, { useMemo } from 'react'
import DatePicker, { DatePickerProps as BzDatePickerProps } from '../../components/DatePicker/DatePicker'

type OptionalDateFieldProps = {
  className?: string
  value?: LocalDateString
  format?: string
  name: string
  size?: DatePickerProps['size']
  onBlur: () => void
  onChange: (e: { target: { value: LocalDateString | undefined } }) => void
  disabledDate?: BzDatePickerProps['disabledDate']
  placeholder?: string
  disabled?: boolean
}

export const OptionalDateField = React.memo(
  React.forwardRef<HTMLInputElement, OptionalDateFieldProps>(
    (
      {
        className,
        value,
        format = 'MMM d, yyyy',
        name,
        size = 'large',
        onBlur,
        onChange,
        disabledDate,
        placeholder,
        disabled,
      },
      ref,
    ) => {
      const parsedValue = useMemo(() => (value ? BzDateFns.parseISO(value, BzDateFns.UTC) : undefined), [value])

      return (
        <DatePicker
          size={size}
          name={name}
          allowClear={true}
          value={parsedValue}
          onBlur={onBlur}
          onChange={date =>
            onChange({
              target: {
                value: date ? BzDateFns.formatLocalDate(bzExpect(date)) : undefined,
              },
            })
          }
          format={format}
          className={classNames('w-full', className)}
          disabledDate={disabledDate}
          placeholder={placeholder}
          disabled={disabled}
        />
      )
    },
  ),
)

OptionalDateField.displayName = 'OptionalDateField'
